module.exports = __webpack_public_path__ + "static/tuberia-b85462cc2d1c2bf1a16b87989a20009d.jpg";